import { Table } from '@octano/global-ui';
import { useCallback } from 'react';
import useColumns from '../hooks/useColumns';
import { useCreditLiquidationDataLoader } from './CreditLiquidationDataLoader';

function CreditLiquidationTable() {
  const {
    data,
    updateQuery,
    query,
    refresh,
  } = useCreditLiquidationDataLoader();

  const handleCreditsUpdated = useCallback(() => {
    refresh();
  }, [refresh]);

  const columns = useColumns({
    periodId: query.periodId || 0,
    onCreditsUpdated: handleCreditsUpdated,
  });

  return (
    <Table
      data={data?.data ?? []}
      columns={columns}
      pagination={{
        totalItems: data?.total ?? 0,
        onChangePage: (page) => updateQuery({ ...query, page }),
        itemsPerPage: 10,
        totalPages: data?.total_pages ?? 0,
        currentPage: query.page,
      }}
    />
  );
}

export default CreditLiquidationTable;
